import { useMemo } from 'react';
import { Form } from 'react-final-form';
import { useHistory } from 'react-router-dom';

import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import { InitialValues } from 'forms/types';
import useNavigatorTracking from 'hooks/useNavigatorTracking';
import Steps from 'hooks/useNavigatorTracking/steps';
import { BENEFIT_AMOUNT_PATH } from 'routes/paths';

import { HEADING, SUBHEADING } from './constants';
import OccupationForm from './form';
import { OccupationFormValues } from './form/types';
import { useGetOccupationQuery } from './graphql/GetSurveyOccupation';
import { useUpdateOccupationMutation } from './graphql/UpdateOccupation';
import buildInitialValues from './utils/buildInitialValues';
import buildInput from './utils/buildInput';
import { validate } from './utils/validate';

const Occupation = () => {
  const trackStepCompleted = useNavigatorTracking(Steps.Occupation);
  const { data, loading } = useGetOccupationQuery();
  const initialValues = useMemo(() => buildInitialValues(data), [data]);
  const history = useHistory();

  const onCompleted = () => {
    trackStepCompleted();
    history.push(BENEFIT_AMOUNT_PATH);
  };

  const [updateOccupation] = useUpdateOccupationMutation({
    onCompleted,
  });

  const onSubmit = (values: OccupationFormValues) =>
    updateOccupation({
      variables: {
        input: buildInput(values),
      },
    });

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <NavigatorContent heading={HEADING} subHeading={SUBHEADING} title={Steps.Occupation}>
      <Form<OccupationFormValues, InitialValues<OccupationFormValues>>
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validate}
      >
        {(formProps) => <OccupationForm {...formProps} />}
      </Form>
    </NavigatorContent>
  );
};

export default Occupation;
